import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircleIcon } from 'lucide-react';

export default function AlertError({
    errors,
    title,
}: {
    errors: string[];
    title?: string;
}) {
    return (
        <Alert variant="destructive">
            <AlertCircleIcon className="text-destructive" color="red" />
            <AlertTitle className="text-destructive">
                {title || 'Something went wrong.'}
            </AlertTitle>
            <AlertDescription className="text-destructive">
                <ul className="list-inside list-disc text-sm">
                    {Array.from(new Set(errors)).map((error, index) => (
                        <li className="text-destructive" key={index}>
                            {error}
                        </li>
                    ))}
                </ul>
            </AlertDescription>
        </Alert>
    );
}
